export interface CommonStandard {
  displayName: string;
  code: string;
  description: string;
}

export const COMMON_STANDARDS: CommonStandard[] = [
  {
    displayName: "ISO/IEC 27001:2022",
    code: "ISO_27001",
    description: "Information Security Management System",
  },
  {
    displayName: "ISO/IEC 27701:2019",
    code: "ISO_27701",
    description: "Privacy Information Management System",
  },
  {
    displayName: "ISO/IEC 42001:2023",
    code: "ISO_42001",
    description: "AI Management System",
  },
  {
    displayName: "SOC 2 Type II",
    code: "SOC2",
    description:
      "Service Organization Controls for Security, Availability, Processing Integrity",
  },
  {
    displayName: "GDPR",
    code: "GDPR",
    description: "EU General Data Protection Regulation",
  },
  {
    displayName: "HIPAA",
    code: "HIPAA",
    description: "Health Insurance Portability and Accountability Act",
  },
  {
    displayName: "PCI DSS v4.0",
    code: "PCI_DSS",
    description: "Payment Card Industry Data Security Standard",
  },
  {
    displayName: "ISO 9001:2015",
    code: "ISO_9001",
    description: "Quality Management System",
  },
  {
    displayName: "ISO 14001:2015",
    code: "ISO_14001",
    description: "Environmental Management System",
  },
  {
    displayName: "TISAX",
    code: "TISAX",
    description:
      "Trusted Information Security Assessment Exchange (Automotive)",
  },
  {
    displayName: "NIST Cybersecurity Framework 2.0",
    code: "NIST_CSF",
    description:
      "Framework for Improving Critical Infrastructure Cybersecurity",
  },
  {
    displayName: "NIST SP 800-53 Rev. 5",
    code: "NIST_800_53",
    description: "Security and Privacy Controls for Information Systems",
  },
  {
    displayName: "ISO 22301:2019",
    code: "ISO_22301",
    description: "Business Continuity Management System",
  },
  {
    displayName: "COBIT 2019",
    code: "COBIT",
    description: "Governance and Management of Enterprise IT",
  },
  {
    displayName: "ISO/IEC 20000-1:2018",
    code: "ISO_20000",
    description: "IT Service Management System",
  },
];
